const config = {
    appId: '0a12d192-0789-4004-ba04-d0e4015bfd70',
    redirectUri: 'https://eportal.rafedsa.com',
    // redirectUri: 'http://localhost:3000/',
    scopes: [
      'user.read',
      //'mailboxsettings.read',
      'calendars.readwrite'
    ]
  };
  
  export default config;
  